import React from 'react';
import clsx from 'clsx';
import { CircularProgress } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { useGetURLParamEntityIdAsNumber, useGetURLParamEntityIdAsString } from '../../utils/utils';
import { EntityDetailsContainer } from './EntityDetailsContainer';


/**
 * This is a page that display all entities. This will display all PROJECT entities or all HOME entities depending on the route.
 * If the user is in a route that has homeId in the URL, this page will display all HOME entities. If the user is NOT in a route
 * that has homeId then this page will display all PROJECT entities
 */
export const EntityDetailsPage: React.FC = () => {

    const location = useLocation();

    // Get the params from the URL
    const projectId = useGetURLParamEntityIdAsNumber('projectId');
    const entityId = useGetURLParamEntityIdAsString('entityId');
    const viewIndex = useGetURLParamEntityIdAsNumber('viewIndex');


    return (
        <div className={clsx('page-main-content')}>
            {projectId && entityId ? (
                <EntityDetailsContainer
                    key={location.pathname}
                    projectId={projectId}
                    entityId={entityId}
                    viewIndex={viewIndex}
                    stickyControlBar
                />
            ) : (
                <CircularProgress />
            )}
        </div>
    );
};
